import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkeletonLoaderComponent implements OnInit {
  @Input()
  mainItemCount: number = 1;

  @Input()
  subItemCount: number = 0;

  @Input()
  appearance: string = '';

  mainItems: any[] = [];
  subItems: any[] = [];

  ngOnInit() {
    this.mainItems.length = this.mainItemCount;
    this.subItems.length = this.subItemCount;
  }
}
